module.exports = __webpack_public_path__ + "static/img/jeonbuk-safety-belt.f760c24.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/jeonbuk-safety-belt.jpg
// module id = J8ZT
// module chunks = 0